import React, {useEffect, useState} from 'react';
import FooterLoginMethod, {loginMethod} from '../login/components/footer-login-method';
import './index.less';
import WechatQrcode, {QrCodeType} from '../../../common/wechat-qrcode';
import { LoginAction } from "@/component/login/actions";
import {
    getMerchantList,
    getMerchantToken,
    queryLoginQrcode,
    queryLoginQrcodeStatus,
    removeLoginData,
    setLoginData,
} from '../utils';
import {setLoginUrlCache, setPlatformTokenInfo, Utils} from '../../../../tools/utils';
import {connect} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';

const LoginQrcode = (props) => {

    const history = useHistory();
    const {search} = useLocation();
    const merchantBelong = new URLSearchParams(search).get('merchantBelong');
    const [qrCodeStatus, setQrCodeStatus] = useState(QrCodeType.新创建二维码);
    const [qrCodeUrl, setQrCodeUrl] = useState('');
    const [qrCodeId, setQrCodeId] = useState('');
    const [isFirst, setIsFirst] = useState(false);

    let timer = null;

    const getQrCode = async () => {
        const {data} = await queryLoginQrcode();
        setQrCodeUrl(data.qrCodeUrl);
        setQrCodeId(data.qrCodeId);
    };

    const refreshQrCode = () => {
        getQrCode();
        setQrCodeStatus(QrCodeType.新创建二维码);
    }

    const getQrCodeStatus = async () => {
        const {data} = await queryLoginQrcodeStatus(qrCodeId);
        switch (data.status) {
            case QrCodeType.已扫码:
                setQrCodeStatus(data.status);
                !isFirst && Utils.customTrack('MerchantTencentisuxQuickMark');
                setIsFirst(true);
                break;
            case QrCodeType.用户授权成功:
                clearInterval(timer);
                const params = {
                    qrCodeId,
                };
                const res = await getMerchantList(params, 'scan');
                if (res.status === 200) {
                    const data = res.data;
                    setLoginData({
                        params: { ...params },
                        loginType: 'scan',
                        merchants: {
                            list: data.rows,
                            total: data.total
                        },
                        needUnifiedPwd: data.needUnifiedPwd
                    });

                    window.localStorage.setItem('loginType', 'scan');
                    localStorage.setItem('subscribeWechat', 'false');

                    const query = merchantBelong ? `?merchantBelong=${merchantBelong}` : ''
                    // 判断是否需要设置统一密码
                    if (data && data.needUnifiedPwd) {
                        history.push({
                            pathname: '/login/unify' + query,
                        });
                        return;
                    }
                    // 判断是否存在多个关联商户，需要选择所登录的商户
                    if (data.total > 1) {
                        history.push('/login/select' + query);
                        return;
                    } else {
                        const getTokenParams = {
                            ...params,
                            orgId: data.rows[0].orgId
                        }
                        localStorage.setItem('orgId', data.rows[0].orgId);
                        const tokenRes = await getMerchantToken(getTokenParams, 'scan');
                        loginSuccess(tokenRes.data);
                        history.replace('/homePage');
                        return;
                    }
                }
                break;
            case QrCodeType.过期:
                setQrCodeStatus(data.status);
                clearInterval(timer);
                break;
            default:
                setQrCodeStatus(QrCodeType.新创建二维码);
                break;
        }
    }

    const loginSuccess = (data) => {
        const _token = data.token_type + data.access_token;
        let { access_token, token_type, refresh_token, expires_in } = data;
        const _tokenInfo = {
            access_token,
            token_type,
            refresh_token,
            expires_in,
            loginWay: 'newLogin',
            nowTime: Date.parse(new Date()) / 1000
        };
        setPlatformTokenInfo(JSON.stringify(_tokenInfo));
        setLoginUrlCache();//缓存登陆url
        removeLoginData();
        props.setToken(_token);
    };

    useEffect(() => {
        clearInterval(timer);
        timer = setInterval(async () => {
            qrCodeId && await getQrCodeStatus();
        }, 1000);

        return () => {
            clearInterval(timer);
        }
    }, [qrCodeId]);

    useEffect(() => {
        getQrCode();
    }, []);

    return (
        <div className="login-qrcode">
            <div className='wrapper'>
                <h3 className="title">微信扫码登录</h3>
                <WechatQrcode qrCodeStatus={qrCodeStatus} qrCodeUrl={qrCodeUrl} refreshQrCode={refreshQrCode} />
            </div>
            <FooterLoginMethod type={loginMethod.手机号登录} />
        </div>
    )
};

export default connect(null, { ...LoginAction })(LoginQrcode);
